import { wacToken } from '@/libraries/design/foundations';

import { IconSvgProps } from '../types';

export const SparkleAI = ({ size }: IconSvgProps) => (
	<svg
		id="icon-content-sparkle-ai"
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M15.5198 3.98611L12.4087 5.54167L15.5198 7.09722L17.0754 10.2083L18.6309 7.09722L21.742 5.54167L18.6309 3.98611L17.0754 0.875L15.5198 3.98611Z"
			fill={wacToken('color.primary.blue')}
		/>
		<path
			d="M7.96458 12.8889L3.07568 15.3333L7.96458 17.7778L10.409 22.6667L12.8535 17.7778L17.7424 15.3333L12.8535 12.8889L10.409 8L7.96458 12.8889Z"
			fill={wacToken('color.primary.blue')}
		/>
	</svg>
);
